import React, { useContext } from 'react'
import { GradesStyles } from './Style'
import { SchoolContext } from './SchoolContext'
import { TestTakers } from '.'

const LearningGroup = (props) => {
    const { learningGroup } = props

    const { invalidTestTakers, gradeOpen, grades, affiliation, classIndexTab, setClassIndexTab } = useContext(SchoolContext)

    return (
        <GradesStyles>
            <div className='divider' />
            <TestTakers
                invalidTestTakers={invalidTestTakers}
                grade={gradeOpen}
                grades={[]}
                affiliation={affiliation}
                // tClass={classes?.[classIndexTab]}
                learningUnit={learningGroup}
                learningUnitKey={"learning_group"}
            />
        </GradesStyles>
    )
}
export default LearningGroup